import React from 'react';

import NextImage from 'next/image';

import { DAY_WEATHER_ICONS, NIGHT_WEATHER_ICONS } from './WeatherConditionIconHelper';

export interface IWeatherConditionIconProps extends React.SVGProps<SVGSVGElement> {
  conditionCode: number;
  conditionIsNight?: boolean;
  width?: number | `${number}`;
  height?: number | `${number}`;
}

export const WeatherConditionIcon = ({
  conditionCode,
  conditionIsNight = false,
  height = '32',
  width = '32',
}: IWeatherConditionIconProps) => {
  if (conditionIsNight) {
    // @ts-ignore
    const src = NIGHT_WEATHER_ICONS[conditionCode];
    return src ? (
      <NextImage alt="Weather Condition Icon Night" width={width} height={height} src={src} />
    ) : (
      <></>
    );
  }
  // @ts-ignore
  const src = DAY_WEATHER_ICONS[conditionCode];
  return src ? (
    <NextImage alt="Weather Condition Icon Day" width={width} height={height} src={src} />
  ) : (
    <></>
  );
};
